module.exports = __webpack_public_path__ + "img/E.78a1155.webp";